export default __webpack_public_path__ + "static/media/MSR.f3ddedd2.svg";